import React, { FC } from "react";
import { useNavigate, useNavigation } from "react-router-dom";
import { ExtractItem } from "src/utils/extractDescription";
import {
	InternalResponse,
	PixResponse,
	SlipResponseTx,
	TedResponse,
} from "./ProofResponses";
import transactionLabel from "src/utils/transactionLabel";
import {
	ButtonWrapper,
	CloseIcon,
	DownloadIcon,
	InfoModal,
	Modal,
	ModalContent,
	ModalHeader,
	Section,
	SectionAccountinfo,
	SectionCPNJ,
	SectionItem,
	SectionPayerName,
	SectionTitle,
} from "../ModalConfirmOperation/styles";
import toLocaleAmount from "src/utils/toLocaleAmount";
import dateToLine from "src/utils/dateToLine";
import { documentFormatted } from "src/utils/documentFormatted";
import { Button } from "../button";
import { config } from "src/config";
import { dateFormat } from "src/utils/dateFormat";

export const Internal: FC<{ data: ExtractItem; closeModal: () => void }> = ({
	data,
	closeModal,
}) => {
	const txType = data.type.toLowerCase();
	const navigate = useNavigate();

	function printPDF() {
		if (!data) return null;

		const receiptString = JSON.stringify(data);

		localStorage.setItem("temp_receipt_to_print", receiptString);

		navigate("/PDF");
	}

	const response = data.data as InternalResponse;

	console.log("data", data);

	const label = transactionLabel(data);

	return (
		<>
			<ModalHeader>
				<div>
					<span>{label}</span>
					<button onClick={closeModal}>
						<CloseIcon />
					</button>
				</div>
			</ModalHeader>
			<ModalContent>
				<InfoModal>
					<div>
						<span>{response?.beneficiary?.name}</span>
						<p>R$ {toLocaleAmount(data.amount)}</p>
					</div>
					<span>{dateToLine(data.created_at)}</span>
				</InfoModal>
				<Section>
					<SectionTitle>Pagador</SectionTitle>
					{data.direction === "in" ? (
						<>
							<SectionPayerName>
								<span>NOME</span>
								<p>{data.payer_bank_name}</p>
							</SectionPayerName>
							<SectionCPNJ>
								<span>
									{response?.payer?.document?.length > 11 ? "CNPJ" : "CPF"}
								</span>
								<p>{documentFormatted(data.payer_document ?? "")}</p>
							</SectionCPNJ>
							<SectionItem>
								<span>INSTITUIÇÃO</span>
								<p>{data.data.data.counterparty_bank_account.bank_number}</p>
							</SectionItem>
						</>
					) : (
						<>
							<SectionPayerName>
								<span>NOME</span>
								<p>{data.data.user.name}</p>
							</SectionPayerName>
							<SectionCPNJ>
								<span>Documento</span>
								<p>{documentFormatted(data.data.user.document)}</p>
							</SectionCPNJ>
							<SectionItem>
								<span>Nº IDENTIFICADOR</span>
								<p>{data.data.user.number_identifier}</p>
							</SectionItem>
						</>
					)}
					<SectionAccountinfo>
						{/* <SectionItem>
              <span>AG</span>
              <p>{response.payer.}</p>
            </SectionItem>
            <SectionItem>
              <span>CONTA</span>
              <p>{response?.payer?.number}</p>
            </SectionItem> */}
					</SectionAccountinfo>
				</Section>
				<Section>
					<SectionTitle>Favorecido</SectionTitle>
					{data.direction === "in" ? (
						<>
							<SectionItem>
								<span>NOME</span>
								<p>{data.data.user.name}</p>
							</SectionItem>
							<SectionItem>
								<span>Documento</span>
								<p>
									{/* @ts-ignore */}
									<p>{documentFormatted(data.data.user.document)}</p>
								</p>
							</SectionItem>
							<SectionItem>
								<span>Nº IDENTIFICADOR</span>
								<p>{data.data.user.number_identifier}</p>
							</SectionItem>
						</>
					) : (
						<>
							<SectionItem>
								<span>NOME</span>
								<p>{data.payer_bank_name}</p>
							</SectionItem>
							<SectionItem>
								<span>Documento</span>
								<p>
									{/* @ts-ignore */}
									{documentFormatted(data.payer_document)}
								</p>
							</SectionItem>
							<SectionItem>
								<span>INSTITUIÇÃO</span>
								<p>{data.data.data.counterparty_bank_account.bank_number}</p>
							</SectionItem>
						</>
					)}
					<SectionAccountinfo>
						{/* <SectionItem>
              <span>AG</span>
              <p>{response.beneficiary.branch}</p>
            </SectionItem>
            <SectionItem>
              <span>CONTA</span>
              <p>{response.beneficiary.number}</p>
            </SectionItem> */}
					</SectionAccountinfo>
				</Section>
				<ButtonWrapper>
					<Button
						handleFunction={printPDF}
						Icon={DownloadIcon}
						title="Baixar Comprovante"
					/>
				</ButtonWrapper>
			</ModalContent>
		</>
	);
};
